
/**
 * Created by satans17 on 2016/12/10.
 */
import $ from '@ali/tarzan-zepto';
import events from 'events';
import TPL from '../baseui/index.js';
import Body from './body/';
import Footer from './footer';
import Welcome from './welcome';
import Header from './head/index';
import Event from './events';
import util from '../../lib/util';

require('./style.scss');

export default class View extends events {
  constructor(config) {
    super();
    this.$container = $(config.container);
    this.log = config.log;
    this.appConfig = config.appConfig;
    this.theme = config.theme ? config.theme : null;
    this.isExternalUI = config.isExternalUI;
    this.receiver = () => {};
    this.initWelcome();
    this.render();
    this.body = this.initBody();
    this.header = this.initHeader();
    this.footer = this.initFooter();
    this.initPull();
    this.initCustomLayout();
    this.bindEvents();
  }

   /**
   * 小蜜加载失败
   * @param message 加载失败原因
   */
  static appLoadFail(message) {
    console.log(message);
  }

  /**
   * 个性化的布局：
   * 1、顶部header隐藏
   * 2、机器人和客服头像显示
   * 3、语音输入，移到下面
   *
   * 触发条件：在不支持隐藏顶部导航的情况下
   */
  initCustomLayout() {
    if (this.appConfig.header) {
      TPL.showAvatar = true;
      this.resize();
    } else {
      this.header.hide();
      this.resize();
    }
  }

  // 初始化欢迎动画
  initWelcome() {
    const fromList = ['alxm', 'zzb', 'fwzs', 'shezhi', 'tmall', 'tmall_mytmall'];
    const hasWelcome = util.storage.getItem('hasWelcome') || '';
    const { hideWelcome, from } = util.queryString.parse(location.search.substring(1)) || {};
    const allowWelcome = fromList.some(f => f === from);

    if (allowWelcome && hideWelcome !== 'true' && hasWelcome !== 'true') {
      const $welcome = new Welcome({
        container: this.$container,
        app: this,
      });
      $welcome.render();
    }
  }

  render() {
    if (this.theme) {
      $(this.$container).addClass(`skin-${this.theme}`);
    }
    this.$container.append(TPL.frame({ type: 'base' }));
    this.$frame = this.$container.find('.m-alicare');
    const { position, size, zIndex, visible } = this.appConfig;
    if (position && size && zIndex) {
      $('body').css({ overflow: 'auto' });
      this.$frame.css({
        right: position.right,
        bottom: position.bottom,
        width: size.width,
        height: size.height,
        top: 'auto',
        left: 'auto',
        zIndex,
        position: 'fixed',
      });
    }

    if (visible) {
      this.$frame.show();
    } else {
      this.$frame.hide();
    }
  }

  /**
   * 重新对齐页面
   */
  resize() {
    this.body.resize(this.footer.$container.height(),
    this.header.$container.height());
  }

  /**
   * @static
   * @param {any} message 刷新
   * @memberOf View
   */
  refresh() {
    this.body.refresh();
  }

  /**
   * @static
   * @param {any} message 滚动到底部
   * @memberOf View
   */
  scrollToBottom() {
    this.body.refresh();
    this.body.scrollToBottom();
  }

  /**
   * @param {any} fn
   * @memberOf View
   */
  append($node) {
    this.body.append($node);
  }
 /**
  * 添加底部插件
  * @param {any} config
  * @memberOf View
  */
  addPlugin(config) {
    this.footer.addPlugin(config);
  }

  /**
   * 设置消息接受对象
   * 不用消息
   */
  setReceiver(fn) {
    if (typeof fn === 'function') {
      this.receiver = fn;
    } else {
      // 类似的错误测试阶段就应该暴漏.
      throw new Error('invalid receiver');
    }
  }

  /**
   * 绑定全局事件
   */
  bindEvents() {
    this.body.$container.on('touchstart', () => {
      this.footer.blur();
      this.footer.hidePlugin();
    });
  }

  /**
   * 初始化footer
   * @return
   * @memberOf View
   */
  initFooter() {
    const f = new Footer({
      log: this.log,
      container: this.$container.find('.m-alicare-footer'),
      size: this.appConfig.size,
    });
    let $voiceNode = null;

    f.on('message', (params) => {
      this.receiver.apply(null, params);
    });
    f.on('resize', () => {
      this.resize();
    });
    f.on('scrollToBottom', () => {
      this.body.refresh();
      this.body.scrollToBottom();
    });
    f.on('voicestart', () => {
      $voiceNode = $(TPL.msg({
        name: 'consumer',
        side: 'right',
        content: '<span style="display:inline-block;width: 60px;">&nbsp;</span>',
      }));
      $voiceNode.addClass('m-chatpanel-voiceinput');
      this.body.append($voiceNode);
    });
    f.on('voicecancel', () => {
      $voiceNode.remove();
      this.refresh();
    });
    f.on('voice', (data) => {
      $voiceNode.find('.J_Content').html(data.text);
      $voiceNode.removeClass('m-chatpanel-voiceinput');
      this.scrollToBottom();
    });
    return f;
  }

  /**
   * 初始化头部
   * @return
   * @memberOf View
   */
  initHeader() {
    const h = new Header({
      log: this.log,
      container: this.$container.find('.m-alicare-header'),
      parentCont: this.$container,
    });
    return h;
  }

  /**
   * 初始化身体，聊天面板
   * @returns
   * @memberOf View
   */
  initBody() {
    const b = new Body({
      log: this.log,
      container: this.$container.find('.m-alicare-body'),
    });
    return b;
  }
  /**
   * 绑定下拉
   * @memberOf View
   */
  initPull() {
    Event.on('pull', () => {
      this.emit('pull');
    });
    this.body.on('pullDistance', (e) => {
      this.header.pullLoading.setDis(e.dis);
    });
  }
  /**
   * 窗口重置
   * @memberOf View
   */
  adjust() {
    window.addEventListener('resize', () => {
      this.resize();
    });
  }
  /**
   * 清空view
   * FOR UI TEST, DON'T DELETE
   */
  empty() {
    $('.m-alicare').remove();
  }
}



// WEBPACK FOOTER //
// ./src/component/view/index.js